import { parseIsoDate, utcDayDiff } from "@/utils/common.utils";
import { getPresentJourneyTitle } from "@/utils/deals-view.utils";

type AnyRecord = Record<string, any>;

/**
 * The one-line "where are we, and when does it close" answer, sitting at the top
 * of every portal before the action card (brief 2.1). Calm and factual — a phase
 * headline plus the closing date and how far off it is — not the retired health
 * pill. Renders nothing pre-contract when there's no closing date to anchor to.
 */
interface PortalStatusBannerProps {
  deal: AnyRecord;
  testId?: string;
}

export default function PortalStatusBanner({ deal, testId = "portal-status-banner" }: PortalStatusBannerProps) {
  const headline = getPresentJourneyTitle(deal?.phase).toUpperCase();
  const terms = deal?.contract_terms || {};
  const closing = parseIsoDate(terms.closing_datetime) || parseIsoDate(terms.closing_date, true);
  const days = closing ? utcDayDiff(closing, new Date()) : null;

  const when = closing
    ? closing.toLocaleDateString(undefined, { month: "long", day: "numeric" })
    : null;
  const away =
    days === null ? null
      : days < 0 ? "closing date passed"
      : days === 0 ? "closing today"
      : days === 1 ? "1 day away"
      : `${days} days away`;

  return (
    <div
      className="mb-6 rounded-2xl border border-dash-border bg-dash-hover px-6 py-5"
      data-testid={testId}
    >
      <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-dash-greenDeep">
        {headline}
      </div>
      {when && (
        <div className="mt-1.5 text-[15px] font-medium text-dash-ink">
          Closing {when}
          {away && <span className="text-dash-muted"> · {away}</span>}
        </div>
      )}
    </div>
  );
}
